import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

class ProdutoGroupRequest extends CrudRequest {
  static baseUrl() {
    return '/produto-servico/produto-agrupamento';
  }

  static list(queryParams = {}) {
    return httpService.get(`${this.baseUrl()}/list-all`, {
      params: queryParams,
    });
  }

  static remove(id) {
    return httpService.delete(`${this.baseUrl()}/${id}`);
  }

  static save(payload) {
    return httpService.post(`${this.baseUrl()}/add`, payload);
  }

  static get(id) {
    return httpService.get(`${this.baseUrl()}/${id}`);
  }

  static edit(id, payload) {
    return httpService.put(`${this.baseUrl()}/${id}`, payload);
  }

  static upload(payload, id) {
    const bodyForm = new FormData();
    bodyForm.append('imageLogo', payload);

    return httpService.post(`${this.baseUrl()}/${id}/add-logo`, bodyForm, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default ProdutoGroupRequest;
